<template>
  <div>
   <treeselect class="border-vb-secondary mt-2 mb-0 pb-1 rounded custom_filter" id="project_status_filter" v-model="selectedModel" @input="$emit('update:selectedFpSpecs', $event)" :multiple="true" :options="fpSpecsFilterOptions" value-consists-of="LEAF_PRIORITY"
    placeholder="Unit Features"/>
  </div>
</template>

<script>
  import { BACKEND_URL } from '../../variables';
  import Treeselect from "@riophae/vue-treeselect";
  export default {
    components:{
      Treeselect
    },
    props:{
      selectedFpSpecs: null,
    },
    computed:{
       selectedModel: {
      get: function () {
        return this.selectedFpSpecs
      },
      set: function (newValue) {
        return newValue
      }
      }
    },
    data: function(){
      return {
        fpSpecsFilterOptions:[],
      }
    },
    methods: {
      async fetchFpSecs(){
        try {
           await $.get(`${BACKEND_URL}api/get_fp_specs_tree`, (response, status) => {
              this.fpSpecsFilterOptions = response.filter(data => !['*','None','Jr Bed','Jr Bed (2)'].includes(data.label)).map(item => ({ id: item.label, label: item.label}))
            });
        } catch (error) {
          console.log(error)
        }
      }
    },
    mounted: function() {
      this.fetchFpSecs()
    }
  }
</script>

<style lang="scss" scoped>

</style>
